import type { QueryClient } from '@tanstack/vue-query'
import type { Page } from '@/lib/api/get-page'
import type { Merchant } from '@/features/merchants/types/merchant'

/** Prefix of every merchants list query: the full list (`useMerchants`) and table pages. */
export const MERCHANTS_QUERY_KEY = ['merchants'] as const

/** One merchant. Not under `MERCHANTS_QUERY_KEY`, whose entries are all lists or pages. */
export function merchantQueryKey(id: number | null) {
  return ['merchant', id] as const
}

/** Every page of a merchant's fetched Merchant Center accounts. */
export function gmcAccountsQueryKey(merchantId: number) {
  return ['gmc-accounts', merchantId] as const
}

/** The leading dot is how Echo addresses a name set by the backend's `broadcastAs()`. */
export const GMC_ACCOUNTS_FETCHED_EVENT = '.merchant.google_accounts_fetched'

/** Applies `update` to every cached merchant, in both full lists and table pages. */
export function updateCachedMerchants(
  queryClient: QueryClient,
  update: (merchant: Merchant) => Merchant,
): void {
  queryClient.setQueriesData<Merchant[] | Page<Merchant>>(
    { queryKey: MERCHANTS_QUERY_KEY },
    (current) => {
      if (!current) return current
      return Array.isArray(current)
        ? current.map(update)
        : { ...current, rows: current.rows.map(update) }
    },
  )
}
